import { render, staticRenderFns } from "./SettingsNotificationSmtpPassword.vue?vue&type=template&id=563bee34&"
import script from "./SettingsNotificationSmtpPassword.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationSmtpPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports